var map = {
	"./1.png": "./src/assets/images/icon/vip/1.png",
	"./10.png": "./src/assets/images/icon/vip/10.png",
	"./11.png": "./src/assets/images/icon/vip/11.png",
	"./12.png": "./src/assets/images/icon/vip/12.png",
	"./2.png": "./src/assets/images/icon/vip/2.png",
	"./3.png": "./src/assets/images/icon/vip/3.png",
	"./4.png": "./src/assets/images/icon/vip/4.png",
	"./5.png": "./src/assets/images/icon/vip/5.png",
	"./6.png": "./src/assets/images/icon/vip/6.png",
	"./7.png": "./src/assets/images/icon/vip/7.png",
	"./8.png": "./src/assets/images/icon/vip/8.png",
	"./9.png": "./src/assets/images/icon/vip/9.png",
	"./ai.png": "./src/assets/images/icon/vip/ai.png",
	"./ai2.png": "./src/assets/images/icon/vip/ai2.png",
	"./streamer.png": "./src/assets/images/icon/vip/streamer.png",
	"./v1.png": "./src/assets/images/icon/vip/v1.png",
	"./v10.png": "./src/assets/images/icon/vip/v10.png",
	"./v2.png": "./src/assets/images/icon/vip/v2.png",
	"./v3.png": "./src/assets/images/icon/vip/v3.png",
	"./v4.png": "./src/assets/images/icon/vip/v4.png",
	"./v5.png": "./src/assets/images/icon/vip/v5.png",
	"./v6.png": "./src/assets/images/icon/vip/v6.png",
	"./v7.png": "./src/assets/images/icon/vip/v7.png",
	"./v8.png": "./src/assets/images/icon/vip/v8.png",
	"./v9.png": "./src/assets/images/icon/vip/v9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/icon/vip sync recursive ^\\.\\/.*\\.png$";